import Vue from 'vue';

import PhotoAlbum from './photo-album/photo-album.vue';
import PhotoAlbumAdvanced from './photo-album-advanced/photo-album-advanced.vue';
import PhotoAlbumAdvancedAlternative from './photo-album-advanced/photo-album-advanced-alternative.vue';
import PhotoAlbumAdvancedNavigation from './photo-album-advanced/photo-album-advanced-navigation.vue';

Vue.component(PhotoAlbum.name, PhotoAlbum);
Vue.component(PhotoAlbumAdvanced.name, PhotoAlbumAdvanced);
Vue.component(PhotoAlbumAdvancedAlternative.name, PhotoAlbumAdvancedAlternative);
Vue.component(PhotoAlbumAdvancedNavigation.name, PhotoAlbumAdvancedNavigation);
